import type { IconSize } from '@shared/components/ui/icon-types';

/** Icon size for sidebar navigation items (excludes chevron toggles) */
export const NAV_ICON_SIZE: IconSize = 'md';

/** Centralized active/inactive style classes for sidebar nav items */
export const NAV_ACTIVE_CLASSES = {
  text: 'text-sidebar-brand',
  border: 'border-sidebar-brand',
  textAndBorder: 'text-sidebar-brand border-sidebar-brand',
} as const;

/** Fixed height of every top-level nav row (expanded and collapsed), density-preserving (~28px today). */
export const NAV_ROW_HEIGHT = 'h-7';

/** Fixed width of the icon/letter slot; goes on the slot element so the glyph centers within it. The slot is left-anchored in both states (never re-centered on collapse), so icons/letters don't shift horizontally. */
export const NAV_ICON_SLOT = 'w-7';

// Note: Profile, Actions, and System are now in the SideNavProfile pop-up menu
